import React from 'react';
import { testimonials } from '../mockData';
import { Star, Quote } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Testimonials = () => {
  const { language } = useLanguage();
  const t = translations[language].testimonials;
  
  return (
    <section id="testimonials" className="py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-20 fade-in">
          <p className="text-[#8B7355] text-sm tracking-widest uppercase mb-4">{t.sectionLabel}</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-['Cormorant_Garamond'] font-light text-[#2c2c2c] mb-6">
            {t.title}
          </h2>
          <div className="w-24 h-0.5 bg-[#8B7355] mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 leading-relaxed">
            {t.description}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-[#FAFAF8] p-8 rounded-sm shadow-md hover:shadow-xl transition-all duration-300 hover-lift relative"
            >
              <Quote className="absolute top-6 right-6 text-[#8B7355] opacity-20" size={40} />
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-[#8B7355] fill-current" size={18} />
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>
              <div className="border-t border-gray-300 pt-4">
                <p className="font-semibold text-[#2c2c2c]">{testimonial.name}</p>
                <p className="text-sm text-gray-500">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-20 text-center">
          <p className="text-gray-600 mb-6 text-lg">
            {t.ctaText}
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-[#8B7355] hover:bg-[#6d5a42] text-white px-10 py-4 rounded-none transition-all duration-300 hover:shadow-xl text-lg font-light"
          >
            {t.ctaBtn}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;